var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLowerY(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 49,
    viewBox: "0 0 32 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.887 4.01863L29.6176 0.358398L31.1303 0.947257L29.3997 4.60749L27.887 4.01863ZM0.0302734 0.999403L1.54107 0.406474L2.41236 2.23425L0.901564 2.82718L0.0302734 0.999403ZM9.58521 21.146L11.0963 20.5538L12.8368 24.2102L11.3257 24.8024L9.58521 21.146ZM7.61771 13.2435L6.10657 13.8357L7.84704 17.4921L9.35818 16.8999L7.61771 13.2435ZM2.63867 6.50013L4.14981 5.90792L5.89028 9.5643L4.37914 10.1565L2.63867 6.50013ZM14.5691 27.8654L13.0583 28.4583L13.9296 30.2861L15.4404 29.6932L14.5691 27.8654ZM7.13538 47.9593L8.8667 44.2993L10.3793 44.8884L8.64799 48.5484L7.13538 47.9593ZM12.326 36.9783L10.5947 40.6383L12.1073 41.2274L13.8387 37.5674L12.326 36.9783ZM14.0604 33.3163L15.7917 29.6563L17.3044 30.2454L15.573 33.9054L14.0604 33.3163ZM26.1718 7.6967L24.4404 11.3567L25.953 11.9458L27.6844 8.2858L26.1718 7.6967ZM19.2574 22.3441L17.5261 26.004L19.0387 26.5931L20.7701 22.9332L19.2574 22.3441ZM20.9747 18.6786L22.7061 15.0187L24.2187 15.6078L22.4873 19.2677L20.9747 18.6786Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowerY);
export default __webpack_public_path__ + "static/media/LOWER_Y.586eb2bec81590f5539e8fab07b8705d.svg";
export { ForwardRef as ReactComponent };